<template>
  <div>
    <input v-model="checked" type="checkbox" class="selectUser">
  </div>
</template>

<script>
export default {
  data(){
    return {
      checked : false,
    }
  },
  props: {
    change:Function,
    data:{},
  },
  created(){
      window.Vue.$on("selectedAllCheckbox", (val)=>{
      this.checked = val;
    })
  },
  watch:{
    'checked'(n , o){
      this.change(this.data, n)
    }
  }
}
</script>